import React from 'react';
import WidgetChipsProps from 'modules/shared/widgets/components/widget-chips/widget-chips.props';
import WidgetTabs from '../../widget-tabs/widget-tabs-desktop/widget-tabs-desktop';
import WidgetTabsTab from '../../widget-tabs/widget-tabs-tab';
import WidgetTabsLabel from '../../widget-tabs/widget-tabs-label';
import WidgetTabsContent from '../../widget-tabs/widget-tabs-content';

import './widget-chips-desktop.scss';

const WidgetChipsDesktop: React.FC<WidgetChipsProps> = ({ data }) => {
    return (
        <WidgetTabs>
            {
                data.map((tab, key) => (
                    <WidgetTabsTab key={key}>
                        <WidgetTabsLabel>{tab.label}</WidgetTabsLabel>
                        <WidgetTabsContent>
                            <ul className="w-chips-d">
                                {
                                    tab.items.map((link, i) => (
                                        <li key={`${tab.label}${i}link`}
                                            className="w-chips-d-item"
                                        >
                                            <a href={link.url} title={link.label}
                                                className="w-chips-d-item-link"
                                            >
                                                {link.img && (
                                                    <div className="w-chips-d-item-link-img-content">
                                                        <img src={link.img} alt={link.label} loading="lazy"
                                                            height={40}
                                                        />
                                                    </div>
                                                )}
                                                {link.label}
                                            </a>
                                        </li>
                                    ))
                                }
                            </ul>
                        </WidgetTabsContent>
                    </WidgetTabsTab>
                ))
            }
        </WidgetTabs>
    );
};

export default WidgetChipsDesktop;
